export default {
  name: 'Shortcut',
  label: {
    title: '快捷导航',
    icon: require('@/assets/icon-component-label_Shortcut.svg'),
    limit: 1
  },
  sort: 1000
}
